import {classNames, layout, View, ViewContent} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {VendingViewHeader} from "./header";
import {useLocalization} from "../i18n";

export interface ErrorViewProps {
    message: string;
    onCancel?: () => void;
}

export function ErrorView({message, onCancel}: ErrorViewProps) {
    const {t} = useLocalization();
    return (
        <View>
            <VendingViewHeader title={t("Error")} onBack={onCancel}/>
            <ViewContent className={classNames(layout.vertical, layout.center, layout.alignCenter)}>
                <div className={styles.errorMessage}>{message}</div>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    errorMessage: {
        flexGrow: 1,
        fontWeight: 'bolder',
        paddingTop: "1.5em",
        paddingBottom: "1.5em",
    },
});
